<template>
    <body>
        <div class="top">
            <div class="top1280">
                <div class="topText1" @click="$router.push('/')">首页 /</div>
                <div class="topText2">申请结业证书</div>
            </div>
        </div>
        <div class="whiteContent">
            <div class="white1280">
                <div class="whiteTitle">申请『吉林一号·遥感开发者培训班』结业证书</div>
                <img src="~@/assets/globalCourse/申请证书_外框.png" alt="" class="whiteBackground">
                <div class="whiteText1">学员<span style="display: inline-block;width: 120px;"></span>于<span style="display: inline-block;width: 150px;"></span> 至<span style="display: inline-block;width: 150px;"></span>参加由长光卫星技术股份有限公司举办的『吉林一号·遥感开发者培训班』，已完成全部学习内容，成绩合格，准予结业。请您准确填写地址信息，以便我们给您寄送实体结业证书。</div>
                <div class="whiteText2">{{name}}</div>
                <div class="whiteLine"></div>
                <div class="whiteText3">{{timeFrom}}</div>
                <div class="whiteText3" style="left: 742px;">{{timeTo}}</div>
                <div v-if="status==1">
                    <div class="whiteText4">邮寄地址</div>
                    <div class="whiteText4" style="top: 830px;">联系电话</div>
                    <v-select
                        v-model="provinceUser"
                        class="area1"
                        :items="provinceList"
                        label="省/自治区/直辖市"
                        placeholder=" "
                        solo
                        :rules="[rules.notNull]"
                    ></v-select>
                    <v-select
                        v-model="cityUser"
                        class="area2"
                        :items="cityList"
                        label="市(区)/县"
                        placeholder=""
                        solo
                        :rules="[rules.notNull]"
                    ></v-select>
                    <v-select
                        v-model="townUser"
                        class="area2"
                        style="left: 949px;width: 244px;"
                        :items="townList"
                        label="区/街道"
                        placeholder=" "
                        solo
                        :rules="[rules.notNull]"
                    ></v-select>
                    <v-text-field
                        v-model="addressUser"
                        class="area3"
                        label="详细地址"
                        placeholder=" "
                        solo
                        :rules="[rules.notNull]"
                    ></v-text-field>
                    <v-text-field
                        v-model="phoneUser"
                        class="area1"
                        style="top: 820px;"
                        label=""
                        placeholder=" "
                        solo
                        :rules="[rules.notNull,rules.phone]"
                    ></v-text-field>
                <div class="submitButton-s" v-if="!submitIsOk">提交申请</div>
                <div class="submitButton" v-if="submitIsOk" @click="submitInformation()">提交申请</div>
                </div>
                <div v-if="status==2">
                    <div class="whiteText5">您已提交申请，我们会尽快为您制作，请保持联系方式畅通。</div>
                    <div class="whiteText9" style="top: 816px;">若有疑问请联系我们的教育专员：0431-86008580</div>
                </div>
                <div v-if="status==3">
                    <div class="whiteText5">您的证书已制作完毕并于 {{sendTime}} 寄出，请保持联系方式畅通</div>
                    <!-- <div class="whiteText6">{{sendTime}}</div> -->
                    <div class="whiteText7">物流公司：{{logistics}}</div>
                    <div class="whiteText8">物流单号：{{logisticsNumber}}</div>
                    <div class="whiteText9">若有疑问请联系我们的教育专员：0431-86008580</div>
                </div>
            </div>
        </div>
    </body>
</template>
<script>
    export default {
      name: "graduationCertificate",
      data() {
        return {
            name:"",
            timeFrom:"2022年12月29日",
            timeTo:"2023年02月17日",
            status:1,
            provinceList:[],
            provinceUser:"",
            cityList:[],
            cityUser:"",
            townList:[],
            townUser:"",
            addressUser:"",
            phoneUser:"",
            sendTime:"2023年02月17日",
            logistics:"顺丰",
            logisticsNumber:"SF1252858967961",
            submitIsOk:false,
            provinceId:0,
            cityId:0,
            provinceName:"",
            cityName:"",
            townName:"",
            rules: {
                notNull: (value) => {
                    if (value == "" || value == null) {
                        return "此项不能为空";
                    } else {
                        return true;
                    }
                },
                phone: (value) => {
                    const pattern = /^[0-9]{11}$/;
                    if (value) {
                        return pattern.test(value) || "请填写正确的手机号码";
                    } else {
                        return true;
                    }
                },
            },
        };
      },
      methods: {
        getKey() {
          return localStorage.getItem("token");
        },
        //登录
        goLogin() {
            let url = "/graduationCertificate";
            this.$router.push("/Login?returnUrl=" + url);
        },
        //获取证书信息
        getUserInformation(){
            if(this.$store.state.user.logined){
                this.axios.post(
                "/learn_back/course/certificate/queryUserCertificateInfo",null,
                {
                headers: {
                    Authorization: "Bearer "+ this.getKey(),
                },
                }
            ) .then((res) =>{
                let resData = res.data;
                if (resData.message=="请求成功") {
                alert("暂无结业相关信息");
                } else {
                console.log(resData.data)
                this.name=resData.data.name
                this.timeFrom=resData.data.startTime
                this.timeTo=resData.data.endTime
                //未申请过结业证书
                if(resData.data.status==0){
                    this.status=1
                    this.phoneUser=resData.data.phone
                    this.addressUser=resData.data.address
                    let location=resData.data.location
                    let a = location.split('/')
                    if(a[0]!=''||a[0]!=null||a[0]!=undefined){
                        this.axios
                        .get("https://www.jl1mall.com/loginapi/api/regions")
                        .then((res) => {
                        this.provinceList = [];
                        let resData = res.data;
                        for (let i = 0; i < resData.length; i++) {
                            let tempObj = {};
                            tempObj.text = resData[i].name;
                            tempObj.value = resData[i];
                            this.provinceList.push(tempObj);
                        }
                        for(let i=0;i<this.provinceList.length;i++){
                            if(a[0]==this.provinceList[i].text){
                                this.provinceUser=this.provinceList[i]
                                this.provinceId=this.provinceList[i].value.id
                                if(a[1]!=''||a[1]!=null||a[1]!=undefined){
                                    this.axios
                                    .get("https://www.jl1mall.com/loginapi/api/regions?parentId=" + this.provinceId)
                                    .then((res) => {
                                    this.cityList = [];
                                    let resData = res.data;
                                    for (let i = 0; i < resData.length; i++) {
                                        let tempObj = {};
                                        tempObj.text = resData[i].name;
                                        tempObj.value = resData[i];
                                        this.cityList.push(tempObj);
                                    }
                                    for(let i=0;i<this.cityList.length;i++){
                                        if(a[1]==this.cityList[i].text){
                                            this.cityUser=this.cityList[i]
                                            this.cityId=this.cityList[i].value.id
                                            if(a[2]!=''||a[2]!=null||a[2]!=undefined){
                                                this.axios
                                            .get("https://www.jl1mall.com/loginapi/api/regions?parentId=" + this.cityId)
                                            .then((res) => {
                                            this.townList = [];
                                            let resData = res.data;
                                            for (let i = 0; i < resData.length; i++) {
                                                let tempObj = {};
                                                tempObj.text = resData[i].name;
                                                tempObj.value = resData[i];
                                                this.townList.push(tempObj);
                                            }
                                            for(let i=0;i<this.townList.length;i++){
                                                if(a[2]==this.townList[i].text){
                                                    this.townUser=this.townList[i]
                                                }
                                            }

                                            });
                                            }
                                        }
                                    }
                                    });
                                }
                                
                            }
                        }
                        
                        });
                    }
                }else if(resData.data.status==1){
                    this.status=2
                }else{
                    this.status=3
                    this.sendTime=resData.data.expressTime
                    this.logistics=resData.data.expressCompany
                    this.logisticsNumber=resData.data.expressId
                }
               
                
            }
            })
            }else{
                this.axios
                .get("/loginapi/getLoginInfo", {
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                },
                })
                .then((resData) =>{
                    if (!resData.data.success) {
                        this.goLogin()
                } else if (resData.data.success){
                    this.$store.state.user.logined = true;
                    this.axios.post(
                    "/learn_back/course/certificate/queryUserCertificateInfo",null,
                    {
                    headers: {
                        Authorization: "Bearer "+ this.getKey(),
                    },
                    }
                ) .then((res) =>{
                    let resData = res.data;
                    if (resData.message=="请求成功") {
                    alert("暂无结业相关信息");
                    } else {
                    console.log(resData.data)
                    this.name=resData.data.name
                    this.timeFrom=resData.data.startTime
                    this.timeTo=resData.data.endTime
                    //未申请过结业证书
                    if(resData.data.status==0){
                        this.status=1
                        this.phoneUser=resData.data.phone
                        this.addressUser=resData.data.address
                        let location=resData.data.location
                        let a = location.split('/')
                        if(a[0]!=''||a[0]!=null||a[0]!=undefined){
                            this.axios
                            .get("https://www.jl1mall.com/loginapi/api/regions")
                            .then((res) => {
                            this.provinceList = [];
                            let resData = res.data;
                            for (let i = 0; i < resData.length; i++) {
                                let tempObj = {};
                                tempObj.text = resData[i].name;
                                tempObj.value = resData[i];
                                this.provinceList.push(tempObj);
                            }
                            for(let i=0;i<this.provinceList.length;i++){
                                if(a[0]==this.provinceList[i].text){
                                    this.provinceUser=this.provinceList[i]
                                    this.provinceId=this.provinceList[i].value.id
                                    if(a[1]!=''||a[1]!=null||a[1]!=undefined){
                                        this.axios
                                        .get("https://www.jl1mall.com/loginapi/api/regions?parentId=" + this.provinceId)
                                        .then((res) => {
                                        this.cityList = [];
                                        let resData = res.data;
                                        for (let i = 0; i < resData.length; i++) {
                                            let tempObj = {};
                                            tempObj.text = resData[i].name;
                                            tempObj.value = resData[i];
                                            this.cityList.push(tempObj);
                                        }
                                        for(let i=0;i<this.cityList.length;i++){
                                            if(a[1]==this.cityList[i].text){
                                                this.cityUser=this.cityList[i]
                                                this.cityId=this.cityList[i].value.id
                                                if(a[2]!=''||a[2]!=null||a[2]!=undefined){
                                                    this.axios
                                                .get("https://www.jl1mall.com/loginapi/api/regions?parentId=" + this.cityId)
                                                .then((res) => {
                                                this.townList = [];
                                                let resData = res.data;
                                                for (let i = 0; i < resData.length; i++) {
                                                    let tempObj = {};
                                                    tempObj.text = resData[i].name;
                                                    tempObj.value = resData[i];
                                                    this.townList.push(tempObj);
                                                }
                                                for(let i=0;i<this.townList.length;i++){
                                                    if(a[2]==this.townList[i].text){
                                                        this.townUser=this.townList[i]
                                                    }
                                                }

                                                });
                                                }
                                            }
                                        }
                                        });
                                    }
                                    
                                }
                            }
                            
                            });
                        }
                    }else if(resData.data.status==1){
                        this.status=2
                    }else{
                        this.status=3
                        let sendTime = resData.data.expressTime
                        sendTime = sendTime.split(' ')[0]
                        let dateArr = sendTime.split('-')
                        let year = dateArr[0]
                        let month = dateArr[1]
                        let day = dateArr[2]
                        this.sendTime = year+'年'+month+'月'+day+'日'
                        this.logistics=resData.data.expressCompany
                        this.logisticsNumber=resData.data.expressId
                    }
                    }
                })
                }
                })
            }
            
            
        },
        //获取省地址
        getNationalAddress1: function () {
        this.axios
            .get("https://www.jl1mall.com/loginapi/api/regions")
            .then((res) => {
            this.provinceList = [];
            let resData = res.data;
            for (let i = 0; i < resData.length; i++) {
                let tempObj = {};
                tempObj.text = resData[i].name;
                tempObj.value = resData[i];
                this.provinceList.push(tempObj);
            }
            });
        },
        //获取市地址
        getNationalAddress2: function (id) {
        this.axios
            .get("https://www.jl1mall.com/loginapi/api/regions?parentId=" + id)
            .then((res) => {
            this.cityList = [];
            let resData = res.data;
            for (let i = 0; i < resData.length; i++) {
                let tempObj = {};
                tempObj.text = resData[i].name;
                tempObj.value = resData[i];
                this.cityList.push(tempObj);
            }
            });
        },
        //获取县、街道地址
        getNationalAddress3: function (id) {
        this.axios
            .get("https://www.jl1mall.com/loginapi/api/regions?parentId=" + id)
            .then((res) => {
            this.townList = [];
            let resData = res.data;
            for (let i = 0; i < resData.length; i++) {
                let tempObj = {};
                tempObj.text = resData[i].name;
                tempObj.value = resData[i];
                this.townList.push(tempObj);
            }

            });
        },
        submitInformation(){
            let province=''
            if(this.provinceUser.text!=null&&this.provinceUser.text!=''&&this.provinceUser.text!=undefined){
                province = this.provinceUser.text
            }else if(this.provinceUser.name!=null&&this.provinceUser.name!=''&&this.provinceUser.name!=undefined){
                province = this.provinceUser.name
            }
            let city = ''
            if(this.cityUser.text!=null&&this.cityUser.text!=''&&this.cityUser.text!=undefined){
                city = this.cityUser.text
            }else if(this.cityUser.name!=null&&this.cityUser.name!=''&&this.cityUser.name!=undefined){
                city = this.cityUser.name
            }
            let town = ''
            if(this.townUser.text!=null&&this.townUser.text!=''&&this.townUser.text!=undefined){
                town = this.townUser.text
            }else if(this.townUser.name!=null&&this.townUser.name!=''&&this.townUser.name!=undefined){
                town = this.townUser.name
            }
            
            let location=province+"/"+city+"/"+town
            var userInfo = {
                location: location,
                address: this.addressUser,
                //phone: this.phoneUser,
                expressCompany:this.logistics,
                expressTime: this.sendTime
            };
            let param = {
                'location': location,
                'address': this.addressUser,
                phone: this.phoneUser,
                'expressCompany':this.logistics,
                'expressTime': this.sendTime
            }
            // param = JSON.stringify(param)
            console.log(location,this.addressUser,this.logistics,this.sendTime);
            this.axios
        .post("/learn_back/course/certificate/add", {
                'location': location,
                'address': this.addressUser,
                'phone': this.phoneUser,
                // 'expressCompany':"",
                // 'expressTime': ""
            }, {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        })
        .then((res) => {
          let resData = res.data;
          if (resData.msg != "success") {
            alert("信息提交失败");
          } else {
            this.status=2
          }
        });
        },
        //申请校验
        buttonColorControl() {
            const regMobile =/^1[3,4,5,6,7,8,9][0-9]{9}$/
            let a=regMobile.test(this.phoneUser)
            if (
                this.provinceUser != null &&
                this.provinceUser != undefined &&
                this.provinceUser != ""&& 
                this.cityUser != null &&
                this.cityUser != undefined &&
                this.cityUser != ""&& 
                this.townUser != null &&
                this.townUser != undefined &&
                this.townUser != ""&&
                this.addressUser != null &&
                this.addressUser != undefined &&
                this.addressUser != ""&& 
                this.phoneUser != null &&
                this.phoneUser != undefined &&
                this.phoneUser != "" &&
                a==true
            ) {
                this.submitIsOk = true;
            } else {
                this.submitIsOk = false;
            }
        },
      },
      mounted() {
        this.getUserInformation()
        //获取省级信息
        this.getNationalAddress1();
        this.$nextTick(() => {
            setInterval(this.buttonColorControl, 200);
            });
      },
      watch:{
        provinceUser: {
        handler: function () {
            this.cityList = [];
            this.cityUser = "";
            this.getNationalAddress2(this.provinceUser.id);
        },
        },
        cityUser: {
        handler: function () {
            this.townList = [];
            this.townUser = "";
            this.getNationalAddress3(this.cityUser.id);
        },
        },
      },
      computed: {
        
      },
    };
    </script>
<style scoped>
    .top{
        position: relative;
        margin-top: 120px;
        width: 100%;
        height: 54px;
        background: #F5F5F6;
    }
    .top1280{
        position: absolute;
        width: 1280px;
        height: 54px;
        left: calc(50% - 640px);
    }
    .topText1{
        position: absolute;
        left: 0px;
        width: 46px;
        height: 22px;
       font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #979797;
        line-height: 54px;
        cursor: pointer;
    }
    .topText2{
        position: absolute;
        left: 56px;
        width: 96px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 54px;
    }
    .whiteContent{
        position: relative;
        width: 100%;
        height: 1210px;
    }
    .white1280{
        position: absolute;
        width: 1280px;
        height: 1210px;
        left: calc(50% - 640px);
    }
    .whiteTitle{
        position: absolute;
        top: 72px;
        left: calc(50% - 300px);
        width: 600px;
height: 28px;
font-size: 20px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 28px;
text-align: center;
    }
    .whiteBackground{
        position: absolute;
        width: 1280px;
        height: 913px;
        top: 160px;
        left: 0;
    }
    .whiteText1{
        position: absolute;
        top: 518px;
        left: 401px;
        width: 800px;
height: 108px;
font-size: 20px;
font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
font-weight: normal;
color: #BA9561;
line-height: 36px;
text-align:justify;

    }
    .whiteText2{
        position: absolute;
        top: 514px;
        left: 452px;
        width: 100px;
        height: 36px;
        font-size: 24px;
font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
font-weight: normal;
color: #3A3A3A;
line-height: 36px;
text-align:center;
    }
    .whiteText3{
        position: absolute;
        top: 518px;
        left: 563px;
        width: 200px;
        height: 36px;
        font-size: 20px;
font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
font-weight: normal;
color: #BA9561;
line-height: 36px;
text-align:center;
    }
    .whiteLine{
        position: absolute;
        top: 543px;
        left: 452px;
        width: 100px;
        height: 2px;
        background-color:#BA9561;
    }
    .whiteText4{
        position: absolute;
        top: 685px;
        left: 401px;
        width: 64px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #3A3A3A;
line-height: 22px;
    }
    .area1 {
  position: absolute;
  top: 675px;
  left: 479px;
  width: 225px;
height: 44px;
background: #FFFFFF;
border-radius: 8px;
border: 1px solid rgba(0,0,0,0.15);
}
.area2{
    position: absolute;
  top: 675px;
  left:714px;
  width: 225px;
height: 44px;
background: #FFFFFF;
border-radius: 8px;
border: 1px solid rgba(0,0,0,0.15);
}
.area3{
    position: absolute;
  top: 736px;
  left: 479px;
  width: 714px;
height: 44px;
background: #FFFFFF;
border-radius: 8px;
border: 1px solid rgba(0,0,0,0.15);
}
::v-deep .v-text-field.v-text-field--solo .v-input__control{
    min-height: 40px;
}
::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot{
    box-shadow: none;
}
::v-deep .theme--light.v-label{
color:#cccccc;
}
/* ::v-deep .theme--light.v-icon{
    color:#cccccc;
} */
.submitButton{
    position: absolute;
    top: 948px;
    left: 565px;
    width: 150px;
height: 54px;
background: rgba(255,255,255,0.25);
border-radius: 27px;
border: 1px solid #C49760;
font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #C49760;
line-height: 54px;
cursor: pointer;
text-align: center;
}
.submitButton:hover{
    background: #C49760;  
color: #FFFFFF;
}
.submitButton-s{
    position: absolute;
    top: 948px;
    left: 565px;
    width: 150px;
height: 54px;
background: rgba(255,255,255,0.25);
border-radius: 27px;
border: 1px solid rgba(0,0,0,0.25);
font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: rgba(0,0,0,0.25);
line-height: 54px;
text-align: center;
}
.whiteText5{
    position: absolute;
    top: 748px;
    left: 401px;
    width: 700px;
height: 28px;
font-size: 20px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 28px;
text-align: left;
}
.whiteText6{
    position: absolute;
    top: 744px;
        left: 606px;
        width: 200px;
        height: 36px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 36px;
text-align:center;
}
.whiteText7{
    position: absolute;
    top: 788px;
    left: 401px;
    width: 500px;
height: 28px;
font-size: 20px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 28px;
}
.whiteText8{
    position: absolute;
    top: 828px;
    left: 401px;
    width: 800px;
height: 28px;
font-size: 20px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 28px;
}
.whiteText9{
    position: absolute;
    top: 896px;
    left: 401px;
    width: 600px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #3A3A3A;
line-height: 22px;
}
</style>